export default {"logMessage": "a188d3f Merge pull request #175 from labsociety/devel"}
